/**
 * Ricerca della persona che scrive in un thread, per mostrarla accanto all'azienda
 * nella riga "Collegato a".
 *
 * Separato dai moduli puri perche' tocca Supabase: i test del progetto girano in
 * ambiente node.
 */
import { supabase } from '../supabase';

export interface ThreadPerson {
  id: string;
  business_name: string;
  email: string | null;
}

/**
 * Persona dell'organizzazione con quell'indirizzo. Cerca anche fra i referenti puri
 * (stato e pipeline nulli), che sono proprio il caso tipico di chi scrive per conto
 * di un'azienda.
 */
export async function findPersonByEmail(
  organizationId: string,
  email: string | null,
): Promise<ThreadPerson | null> {
  const target = (email || '').trim();
  if (!target || !organizationId) return null;

  const { data } = await supabase
    .from('clients')
    .select('id, business_name, email')
    .eq('organization_id', organizationId)
    .eq('entity_type', 'individual')
    .ilike('email', target)
    .limit(1);

  const row = data?.[0];
  return row ? { id: row.id, business_name: row.business_name, email: row.email } : null;
}
